// ════════════════════════════════════════════════════════════════════════
//  Die Urkunde in den Downloadordner des Browsers reichen.
//
//  Wie bei den Kärtchen: für einen Ausdruck gibt es keinen Grund, etwas über
//  einen Server zu schicken. Ausgelagert aus der Ansicht, weil es der einzige
//  Teil davon ist, der das DOM anfasst.
// ════════════════════════════════════════════════════════════════════════

import { useCallback, useState } from "react";
import {
  certificateFileName,
  createCertificatePdf,
  type CertificateInput,
} from "../lib/certificate.js";

export function useCertificateDownload() {
  const [printing, setPrinting] = useState(false);

  const download = useCallback(async (input: CertificateInput) => {
    setPrinting(true);
    try {
      const bytes = await createCertificatePdf(input);
      const url = URL.createObjectURL(
        new Blob([bytes as BlobPart], { type: "application/pdf" }),
      );
      const link = document.createElement("a");
      link.href = url;
      const students = input.students ?? [];
      link.download = certificateFileName(
        input.schoolClass,
        input.schoolYear,
        students.length > 0,
        students.length === 1 ? students[0]!.code : undefined,
      );
      link.click();
      URL.revokeObjectURL(url);
    } finally {
      setPrinting(false);
    }
  }, []);

  return { printing, download };
}
